import React from 'react';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';

import './DimensionValuesTable.css';

const DimensionValuesTable = ({ dimensionValues }) => {

    const headers = [
        { label: 'Order', align: 'center' },
        { label: 'Name', align: 'left' },
    ];

    const rows = dimensionValues ? dimensionValues.map((dimValue) => ({
        id: dimValue.dimensionValueOrder,
        cells: [
            { content: `${dimValue.dimensionValueOrder}`, align: 'center' },
            { content: `${dimValue.dimensionValueName}`, align: 'left' },
        ]
    })) : [];

    return (
        (dimensionValues && dimensionValues.length > 0 &&
            < B2BTableInMemory
                headers={headers} rows={rows}
                className={"dimension-values-list-table"}
                numRows={10}
                stickyHeader={true}
            />
        )
    );
};

export default DimensionValuesTable;